export default "<p>base-crud works!</p>\r\n"